import React, { useState, useEffect } from 'react';
import { motion } from 'framer-motion';
import { auth } from '../firebase';
import { signOut } from 'firebase/auth';
import { useNavigate } from 'react-router-dom';
import { FaBolt, FaSignOutAlt, FaHome } from 'react-icons/fa';
import AdminLayout from '../components/admin/AdminLayout';

const AdminPanel = () => {
  const [user, setUser] = useState(null);
  const navigate = useNavigate();

  useEffect(() => {
    setUser(auth.currentUser);
  }, []);

  const handleLogout = async () => {
    try {
      await signOut(auth);
      navigate('/login');
    } catch (error) {
      console.error('Logout error:', error);
    }
  };

  return (
    <div className="min-h-screen bg-gradient-to-b from-[#0a0a1f] via-[#1a1a3e] to-[#0a0a1f]">
      {/* Header */}
      <nav className="bg-[#0a0a1f] border-b border-gray-800 sticky top-0 z-50">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="flex items-center justify-between h-16">
            <div className="flex items-center gap-2">
              <div className="w-8 h-8 bg-gradient-to-br from-purple-500 to-pink-500 rounded-lg flex items-center justify-center">
                <FaBolt className="text-white" size={18} />
              </div>
              <span className="text-white font-bold text-xl">Admin Panel</span>
            </div>

            <div className="flex items-center gap-3">
              <div className="hidden sm:block text-right">
                <p className="text-white text-sm font-medium">{user?.email}</p>
                <p className="text-gray-400 text-xs">Administrator</p>
              </div>
              
              <motion.button
                onClick={() => navigate('/')}
                className="px-4 py-2 bg-[#1a1a3e] hover:bg-[#2a2a4e] text-white rounded-lg flex items-center gap-2 transition-colors border border-gray-700"
                whileHover={{ scale: 1.05 }}
                whileTap={{ scale: 0.95 }}
              >
                <FaHome />
                <span className="hidden sm:inline">Home</span>
              </motion.button>
              
              <motion.button
                onClick={handleLogout}
                className="px-4 py-2 bg-red-500 hover:bg-red-600 text-white rounded-lg flex items-center gap-2 transition-colors"
                whileHover={{ scale: 1.05 }}
                whileTap={{ scale: 0.95 }}
              >
                <FaSignOutAlt />
                <span className="hidden sm:inline">Logout</span>
              </motion.button>
            </div>
          </div>
        </div>
      </nav>

      {/* Admin Layout with Sidebar and Content */}
      <AdminLayout />
    </div>
  );
};

export default AdminPanel;
